import { applyMiddleware, createStore } from "redux";
import { thunk } from "redux-thunk";
import reducers from "../reducers";
import firestoreConfig from "configs/FirestoreConfig";
import firebase from "configs/FirebaseConfig";
import { createFirestoreInstance } from "redux-firestore";
import { save } from "redux-localstorage-simple";

const composeEnhancers = (f) => f;

// Geen load() als preloadedState: die vervangt de theme-slice compleet, waardoor
// nieuwe velden uit initTheme (bv. navType) ontbreken bij bestaande gebruikers.
// De theme-reducer leest localStorage zelf en merget over initTheme heen.
const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk, save({ ignoreStates: ["queries"] }))));

export const rrfProps = {
  firebase,
  config: firestoreConfig,
  dispatch: store.dispatch,
  createFirestoreInstance,
};

export default store;
